import { render, staticRenderFns } from "./word-choose-translate.vue?vue&type=template&id=eb36d408&scoped=true&"
import script from "./word-choose-translate.vue?vue&type=script&lang=js&"
export * from "./word-choose-translate.vue?vue&type=script&lang=js&"
import style0 from "./word-choose-translate.vue?vue&type=style&index=0&id=eb36d408&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb36d408",
  null
  
)

export default component.exports